import React from 'react';
import './stock_summary_help.css';
import HelpCard from '../HelpCard';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../redux/actions/action-creator';

const Stock_Summary_Help = (props) => {
    const dispatch = useDispatch();

    const fields = [
        { id: "1", name: "Period", shortcutKey: "F2", state: () => dispatch(openModal('period')) },
        { id: "2", name: "Detailed / Condensed", shortcutKey: "F1", state: () => dispatch(openModal('detailedCondensed')) },
        /*{ id: "2", name: "Group Wise", shortcutKey: "F3", state: () => dispatch(openModal('stockGroup')) },*/
        {
            id: "3", name: "Group / Item / Category / Company", shortcutKey: "F4", state: () => {
                const filter = props.date?.filter_name;
                if (filter === 'Group-Wise') {
                    dispatch(openModal("stockGroup"));
                } else if (filter === 'Category-Wise') {
                    dispatch(openModal("stockCate"));
                } else if (filter === 'Company-Wise') {
                    dispatch(openModal("stockCompany"));
                } else {
                    dispatch(openModal("itemWise"));
                }
            }, disabled: !props.f4Enable
        },
        /*{ id: "4", name: "Category Wise", shortcutKey: "F5", state: () => dispatch(openModal('stockCate')) },
        { id: "5", name: "Company Wise", shortcutKey: "F6", state: () => dispatch(openModal('stockCompany')) },*/
        { id: "4", name: "Summary Type", shortcutKey: "F5", state: () => dispatch(openModal('summaryType')) },
        { id: "5", name: "Period Type", shortcutKey: "F6", state: () => dispatch(openModal('periodType')) },
        { id: "6", name: "Godown", shortcutKey: "F7", state: () => dispatch(openModal('godownWise')) },
        { id: "7", name: "Apply Filter", shortcutKey: "F", state: () => dispatch(openModal('applyFilter')) },
        { id: "8", name: "Share", shortcutKey: "S", state: () => dispatch(openModal('share')) },
        { id: "9", name: "Print", shortcutKey: "P", state: () => dispatch(openModal('print')) },
        /*{ id: "7", name: "Monthly", shortcutKey: "F8", },
        { id: "8", name: "Show Profit", shortcutKey: "F9", },
        { id: "9", name: "Valuation", shortcutKey: "F9", state: () => dispatch(openModal('valuation')) },
        { id: "10", name: "Basis of Value", shortcutKey: "F9", state: () => dispatch(openModal('basic')) },
        { id: "11", name: "Change View", shortcutKey: "F9", state: () => dispatch(openModal('changeView')) },
        { id: "12", name: "Exception Reposts", shortcutKey: "F9", state: () => dispatch(openModal('exceptionReports')) },
        { id: "13", name: "Save View", shortcutKey: "F9", state: () => dispatch(openModal('saveView')) },*/
    ]

    return (
        <>
            {
                fields.map((item, index) => {
                    return (
                        <HelpCard key={item.id} fields={item} />
                    )
                })
            }
            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <div className='help_button_card  ms-1' >
                    <button className={`button_padding`}
                        style={{ background: 'white', paddingTop: 3, paddingBottom: 3, marginBottom: 2 }}
                        onClick={
                            () => dispatch(openModal('configure'))
                        }>
                        <p className='card-header'>
                            <span>F12</span>:
                            Configure
                        </p>
                    </button>
                </div>
            </div>

        </>
    )
}

export default Stock_Summary_Help;
